import { createActions, createActionTypesConfig } from '../helpers';

export const INTERNAL_REQUEST_LABEL = 'internalRequest';

/** Action Types */

export const CREATE_INTERNAL_REQUEST_TYPES = createActionTypesConfig(
  INTERNAL_REQUEST_LABEL,
  'CREATE_INTERNAL_REQUEST'
);

export const SUBMIT_INTERNAL_REQUEST_TYPES = createActionTypesConfig(
  INTERNAL_REQUEST_LABEL,
  'SUBMIT_INTERNAL_REQUEST'
);

export const APPROVE_INTERNAL_REQUEST_TYPES = createActionTypesConfig(
  INTERNAL_REQUEST_LABEL,
  'APPROVE_INTERNAL_REQUEST'
);

export const REJECT_INTERNAL_REQUEST_TYPES = createActionTypesConfig(
  INTERNAL_REQUEST_LABEL,
  'REJECT_INTERNAL_REQUEST'
);

export const MF_APPROVE_INTERNAL_REQUEST_TYPES = createActionTypesConfig(
  INTERNAL_REQUEST_LABEL,
  'MF_APPROVE_INTERNAL_REQUEST'
);

export const CLOSE_INTERNAL_REQUEST_TYPES = createActionTypesConfig(
  INTERNAL_REQUEST_LABEL,
  'CLOSE_INTERNAL_REQUEST'
);

export const UPDATE_INTERNAL_REQUEST_TYPES = createActionTypesConfig(
  INTERNAL_REQUEST_LABEL,
  'UPDATE_INTERNAL_REQUEST'
);

export const GET_INTERNAL_REQUESTS_TYPES = createActionTypesConfig(
  INTERNAL_REQUEST_LABEL,
  'GET_INTERNAL_REQUESTS'
);

export const FIND_INTERNAL_REQUEST_TYPES = createActionTypesConfig(
  INTERNAL_REQUEST_LABEL,
  'FIND_INTERNAL_REQUEST'
);

export const DELETE_INTERNAL_REQUEST_TYPES = createActionTypesConfig(
  INTERNAL_REQUEST_LABEL,
  'DELETE_INTERNAL_REQUEST'
);

export const GET_ADMIN_QUEUE_TYPES = createActionTypesConfig(
  INTERNAL_REQUEST_LABEL,
  'GET_ADMIN_QUEUE'
);

export const GET_PENDING_CLOSE_QUEUE_TYPES = createActionTypesConfig(
  INTERNAL_REQUEST_LABEL,
  'GET_PENDING_CLOSE_QUEUE'
);

/** Actions */

export const CREATE_INTERNAL_REQUEST_ACTION = createActions(
  CREATE_INTERNAL_REQUEST_TYPES
);

export const SUBMIT_INTERNAL_REQUEST_ACTION = createActions(
  SUBMIT_INTERNAL_REQUEST_TYPES
);

export const APPROVE_INTERNAL_REQUEST_ACTION = createActions(
  APPROVE_INTERNAL_REQUEST_TYPES
);

export const REJECT_INTERNAL_REQUEST_ACTION = createActions(
  REJECT_INTERNAL_REQUEST_TYPES
);

export const MF_APPROVE_INTERNAL_REQUEST_ACTION = createActions(
  MF_APPROVE_INTERNAL_REQUEST_TYPES
);

export const CLOSE_INTERNAL_REQUEST_ACTION = createActions(
  CLOSE_INTERNAL_REQUEST_TYPES
);

export const UPDATE_INTERNAL_REQUEST_ACTION = createActions(
  UPDATE_INTERNAL_REQUEST_TYPES
);

export const GET_INTERNAL_REQUESTS_ACTION = createActions(
  GET_INTERNAL_REQUESTS_TYPES
);

export const FIND_INTERNAL_REQUEST_ACTION = createActions(
  FIND_INTERNAL_REQUEST_TYPES
);

export const DELETE_INTERNAL_REQUEST_ACTION = createActions(
  DELETE_INTERNAL_REQUEST_TYPES
);

export const GET_ADMIN_QUEUE_ACTION = createActions(GET_ADMIN_QUEUE_TYPES);

export const GET_PENDING_CLOSE_QUEUE_ACTION = createActions(
  GET_PENDING_CLOSE_QUEUE_TYPES
);
